import {
  LOGIN_BANNER_LCP_IMAGE_URL,
} from '@/pages/Login/enum/index';

const LOGIN_BANNER_PRELOAD_LINK_ID = 'login-banner-lcp-preload';

/** 登录页首屏 LCP 为 Banner 大图，路由进入时尽早 preload，勿等 React 挂载后再拉 jdios */
export function preloadLoginBannerLcpImage(imageUrl: string = LOGIN_BANNER_LCP_IMAGE_URL): void {
  if (!imageUrl || typeof document === 'undefined') {
    return;
  }

  const existing = document.getElementById(LOGIN_BANNER_PRELOAD_LINK_ID) as HTMLLinkElement | null;
  if (existing) {
    if (existing.href !== imageUrl) {
      existing.href = imageUrl;
    }
    return;
  }

  const link = document.createElement('link');
  link.id = LOGIN_BANNER_PRELOAD_LINK_ID;
  link.rel = 'preload';
  link.as = 'image';
  link.href = imageUrl;
  link.setAttribute('fetchpriority', 'high');
  document.head.appendChild(link);
}
